export default {"src":"/_next/static/media/AMGN.4cb85196.svg","height":18,"width":18};